import { Anchor, Button, Flex, Stack } from "@mantine/core";
import React, { useState } from "react";
import McInputNew from "../McInput/McInputNew";
import McTextAreaNew from "../McInput/McTextAreaNew";
import McTitle from "../McTitle/McTitle";

const ContactForm: React.FC<{
  sendMessage: (message: string, subject: string) => Promise<void>;
  prefilledSubject?: string;
}> = ({ sendMessage, prefilledSubject }) => {
  const [message, setMessage] = useState<string>("");
  const [subject, setSubject] = useState<string>(prefilledSubject != null ? prefilledSubject : "");

  return (
    <Stack align="center">
      <Stack>
        <Stack>
          <McTitle title="Emne">
            <McInputNew mb="0.5rem" autoFocus={true} value={subject} onChange={(e) => setSubject(e.target.value)} />
          </McTitle>
          <McTitle title="Melding">
            <McTextAreaNew
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Synspunkter, forslag, problemer..."
            />
          </McTitle>
          <Button
            variant="filled"
            disabled={message.length < 10 || subject.length < 1}
            onClick={() => sendMessage(subject, message)}
          >
            Send
          </Button>
        </Stack>
        <Flex gap="xs">
          Eller send en e-post til:
          <Anchor href="mailto:mcapps@multiconsult.no" rel="noreferrer" target="_blank">
            mcapps@multiconsult.no
          </Anchor>
        </Flex>
      </Stack>
    </Stack>
  );
};

export default ContactForm;
